import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllTaxTable from './components/AllTaxTable';

function TaxPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Steuern" />
      <ErrorBoundaries>
        <AllTaxTable />
      </ErrorBoundaries>
    </>
  );
}

export default TaxPage;
